export const isEAN = (ean) => {
  if (!/^[0-9]{13}$/.test(ean)) return false; // El EAN-13 debe tener exactamente 13 dígitos numérico

  const digits = ean.split('').map(Number);
  const checksum = digits.pop(); // Extraer el dígito de control

  const sum = digits.reduce((acc, digit, index) => {
    if (index % 2 === 0) {
      return acc + digit;
    }
    return acc + digit * 3;
  }, 0);

  const calculatedChecksum = (10 - (sum % 10)) % 10;
  return checksum === calculatedChecksum;
};

export const isUPC = (upc) => {
  if (!/^[0-9]{12}$/.test(upc)) return false; // El UPC debe tener exactamente 12 dígitos numéricos

  const digits = upc.split('').map(Number);
  const checksum = digits.pop(); // Extraer el dígito de control

  const oddSum = digits.filter((_, index) => index % 2 === 0).reduce((acc, digit) => acc + digit, 0);
  const evenSum = digits.filter((_, index) => index % 2 !== 0).reduce((acc, digit) => acc + digit, 0);

  const calculatedChecksum = (10 - ((oddSum * 3 + evenSum) % 10)) % 10;
  return checksum === calculatedChecksum;
};
